/**
 * How the distribution is cut into bars.
 *
 * The question a p95 cannot answer. A bimodal shape usually means a cache, a
 * retry, or two callers doing different amounts of work under one name, and no
 * single percentile will ever show it.
 */// The cut a reader lands on. Offered as a control because the right answer
// depends on the data: a wide bucket hides a second population and a narrow
// one turns a hundred readings into a hundred bars of one.
export const DEFAULT_BUCKET_COUNT=24;// How finely the distribution may be cut. The coarse end matters as much as
// the fine one: two or four buckets is how a bimodal shape shows itself, where
// forty-eight scatters the same readings into a row of ones.
export const BUCKET_CHOICES=[2,4,6,8,10,12,24,48];/**
 * Bucket completed durations linearly from zero to the slowest reading.
 *
 * From zero rather than from the fastest, because "how close to instant is
 * this" is part of what the shape says, and a floor at the minimum would hide
 * a metric whose fast population sits at 2 ms by drawing it at the origin.
 *
 * Trimming outliers is deliberately not done: the slow tail is the reason
 * anyone opens this page, and a chart that quietly dropped the worst reading
 * would be hiding the finding.
 */export function buildHistogram(durationsMs,bucketCount){if(durationsMs.length===0){return null;}const slowest=Math.max(...durationsMs);// Every reading identical (including all-zero) has no range to divide, so it
// is one bucket holding everything rather than a division by zero.
const span=slowest>0?slowest:1;const width=span/bucketCount;// The element type is written out rather than left to inference: a bare
// `new Array(n)` gives Flow a length and nothing to infer the element type
// from, and `.fill(0)` afterwards is too late to constrain it.
const counts=new Array(bucketCount).fill(0);for(const duration of durationsMs){// The slowest reading lands exactly on the top edge, which would index one
// past the end; it belongs in the last bucket.
const index=Math.min(Math.floor(duration/width),bucketCount-1);counts[index]+=1;}return{buckets:counts.map((count,index)=>({fromMs:index*width,toMs:(index+1)*width,count})),peakCount:Math.max(...counts)};}